import React from 'react';
import { Badge, Tooltip, Space } from 'antd';
import { WifiOutlined, LoadingOutlined, DisconnectOutlined } from '@ant-design/icons';
import { useSocketContext } from '../providers';

/**
 * 连接状态指示器组件
 * 显示 WebSocket 连接状态
 */
const ConnectionStatus: React.FC = () => {
    const { connected, connecting, error, connect } = useSocketContext();

    if (connecting) {
        return (
            <Tooltip title="正在连接实时服务...">
                <Space size={4}>
                    <LoadingOutlined style={{ color: '#faad14' }} />
                    <span style={{ fontSize: 12, color: '#faad14' }}>连接中</span>
                </Space>
            </Tooltip>
        );
    }

    if (error || !connected) {
        return (
            <Tooltip title={error ? `连接失败: ${error.message}` : '未连接到实时服务，点击重连'}>
                <Space
                    size={4}
                    style={{ cursor: 'pointer' }}
                    onClick={connect}
                >
                    <Badge status="error" />
                    <DisconnectOutlined style={{ color: '#ff4d4f' }} />
                    <span style={{ fontSize: 12, color: '#ff4d4f' }}>离线</span>
                </Space>
            </Tooltip>
        );
    }

    return (
        <Tooltip title="实时服务已连接">
            <Space size={4}>
                <Badge status="success" />
                <WifiOutlined style={{ color: '#52c41a' }} />
                <span style={{ fontSize: 12, color: '#52c41a' }}>在线</span>
            </Space>
        </Tooltip>
    );
};

export default ConnectionStatus;
